import React, { useRef } from 'react'
import PropTypes from 'prop-types'
import ReCAPTCHA from 'react-google-recaptcha'
import Typography from '@material-ui/core/Typography'

/**
 * Google reCAPTCHA v2 checkbox.
 *
 * Default `compact` is the square 164×144 widget used by shared forms.
 * `normal` is the horizontal 304×78 widget — pass it from the flagged
 * coach-profile lead form only.
 *
 * An expired check always clears the token. With `resetOnExpire`, the widget
 * also resets to a fresh checkbox, because Google's own expired message is
 * drawn inside its iframe and can't be styled; the form shows its own copy
 * from `onExpired` instead.
 */
function Recaptcha({
  setToken, error, size = 'compact', resetOnExpire = false, onExpired,
}) {
  const recaptchaRef = useRef(null)

  const handleExpired = () => {
    setToken?.(null)
    if (resetOnExpire) recaptchaRef.current?.reset()
    onExpired?.()
  }

  return (
    <div style={{
      marginBottom: '10px', maxWidth: '100%', width: 'fit-content', overflow: 'hidden',
    }}
    >
      <ReCAPTCHA
        ref={recaptchaRef}
        sitekey={process.env.RECAPTCHA_V2_KEY}
        size={size}
        onChange={(token) => setToken(token)}
        onExpired={handleExpired}
      />
      {error && <Typography style={{ color: 'red', fontSize: '12px' }}>{error}</Typography>}
    </div>
  )
}

Recaptcha.propTypes = {
  setToken: PropTypes.func,
  error: PropTypes.string,
  size: PropTypes.oneOf(['normal', 'compact']),
  resetOnExpire: PropTypes.bool,
  onExpired: PropTypes.func,
}

export default Recaptcha
